import Head from 'next/head'
import Page from '../components/Page'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CommonHeadTags from '../components/CommonHeadTags'
import {
  GoogleAnalyticsHead,
  GoogleAnalyticsBody,
} from '../components/GoogleAnalytics'
import withLocale from '../translations/withLocale'
import useTranslation from '../translations/useTranslation'
import { nonEnglishLocales, localeHreflangs } from '../translations/config'

function ElectricGuitar() {
  const { t } = useTranslation()
  return (
    <>
      <Head>
        <title>{t('title-electric-guitar')}</title>
        <meta name='description' content={t('description-electric-guitar')} />
        <meta httpEquiv='content-language' content='en' />
        <link
          rel='canonical'
          href='https://guitar-tuner.org/electric-guitar-tuning'
        />
        <link
          rel='alternate'
          hrefLang='x-default'
          href='https://guitar-tuner.org/electric-guitar-tuning'
        />
        <link
          rel='alternate'
          hrefLang='en'
          href='https://guitar-tuner.org/electric-guitar-tuning'
        />
        {nonEnglishLocales.map((locale) => (
          <link
            key={locale}
            rel='alternate'
            hrefLang={localeHreflangs[locale]}
            href={`https://guitar-tuner.org/${locale}/electric-guitar-tuning`}
          />
        ))}
        <CommonHeadTags
          title={t('title-electric-guitar')}
          description={t('description-electric-guitar')}
          url='https://guitar-tuner.org/electric-guitar-tuning'
        />
        <GoogleAnalyticsHead />
      </Head>

      <Header instrument='electric-guitar'/>

      <main>
        <Page
          instrument='electric-guitar'
          pageData='electric-guitar-tuning'
        />
      </main>

      <Footer />
      <GoogleAnalyticsBody />
    </>
  )
}

export default withLocale(ElectricGuitar)
